import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "campaignName", "durationDays", "totalCost", "minimumInvestmentHint",
    "submitButton", "errorMessage",
    "regionType", "specificRegion"
  ]

  connect() {
    this.#initializeMoneyMask();
    this.validateForm();
    this.updateMinimumInvestmentHint();
  }

  validateForm() {
    const validation = this.getValidationResult()
    const isValid = validation.isValid

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = !isValid

      if (isValid) {
        this.submitButtonTarget.classList.remove("disabled")
        this.hideErrorMessage()
      } else {
        this.submitButtonTarget.classList.add("disabled")
        this.showErrorMessage(validation.errorMessage)
      }
    }
  }

  getValidationResult() {
    const campaignName = this.campaignNameTarget.value.trim()

    if (campaignName.length < 3) {
      return { isValid: false, errorMessage: "Nome da campanha deve ter pelo menos 3 caracteres" }
    }

    if (!this.durationDaysTarget.value) {
      return { isValid: false, errorMessage: "Selecione a duração da campanha" }
    }

    const minimumCents = this.#currentMinimumCents()
    const totalCostCents = this.#parsedTotalCostCents()
    if (!totalCostCents || totalCostCents < minimumCents) {
      const minimumValue = (minimumCents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      return { isValid: false, errorMessage: `Investimento mínimo para esta seleção é ${minimumValue}` }
    }

    if (this.hasRegionTypeTarget) {
      const checkedRegion = this.regionTypeTargets.find(el => el.checked)
      if (checkedRegion && checkedRegion.value === 'specific') {
        const select = this.specificRegionTarget.querySelector('select')
        const selectedCount = select ? Array.from(select.options).filter(o => o.selected).length : 0
        if (selectedCount === 0) {
          return { isValid: false, errorMessage: "Selecione pelo menos um estado para Região Específica" }
        }
      }
    }

    return { isValid: true, errorMessage: null }
  }

  showErrorMessage(message) {
    if (this.hasErrorMessageTarget) {
      const messageElement = this.errorMessageTarget.querySelector('p')
      if (messageElement) {
        messageElement.textContent = message
      }
      this.errorMessageTarget.style.display = "block"
    }
  }

  hideErrorMessage() {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.style.display = "none"
    }
  }

  validateCampaignName() {
    this.validateForm()
  }

  validateDurationDays() {
    this.updateMinimumInvestmentHint()
    this.validateForm()
  }

  validateTotalCost() {
    this.validateForm()
  }

  validateRegion() {
    this.validateForm()
  }

  toggleRegion() {
    const checkedRegion = this.regionTypeTargets.find(el => el.checked)
    if (checkedRegion && checkedRegion.value === 'specific') {
      this.specificRegionTarget.style.display = 'block'
    } else {
      this.specificRegionTarget.style.display = 'none'
      const select = this.specificRegionTarget.querySelector('select')
      if (select) {
        Array.from(select.options).forEach(opt => { opt.selected = false })
      }
    }
    this.validateForm()
  }

  updateMinimumInvestmentHint() {
    if (!this.hasMinimumInvestmentHintTarget) return

    const minimumCents = this.#currentMinimumCents()
    if (!minimumCents) {
      this.minimumInvestmentHintTarget.style.display = "none"
      return
    }

    const minimumValue = (minimumCents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    this.minimumInvestmentHintTarget.textContent = `Investimento mínimo: ${minimumValue}`
    this.minimumInvestmentHintTarget.style.display = "inline-block"
  }

  #currentMinimumCents() {
    const option = this.durationDaysTarget.selectedOptions[0]
    return option ? parseInt(option.dataset.minimumCents || '0', 10) : 0
  }

  #parsedTotalCostCents() {
    if (!this.hasTotalCostTarget) return 0
    const digits = $(this.totalCostTarget).cleanVal();
    return digits ? parseInt(digits, 10) : 0
  }

  #initializeMoneyMask() {
    $(".impulse-total-cost-input").mask("#.##0,00", { reverse: true });
  }
}
